import { useFormContext } from "react-hook-form";
import { classes } from "../../../../util/style-utils";

export default function AgencyNameField() {
    const { register, formState: { errors }, clearErrors } = useFormContext();

    return (
        <div className="flex-row">
            <div className={classes("form-field", errors.agencyName && "form-field--error")}>
                <label htmlFor="agency-name" className="text">
                    Agency Name<span className="required">*</span>
                </label>
                <input
                    id="agency-name"
                    type="text"
                    size="30"
                    maxLength={100}
                    placeholder="Agency Name"
                    {...register("agencyName", { onBlur: () => { clearErrors("agencyName"); } })}
                />
                {errors.agencyName && (
                    <span className="form-message">
                        {errors.agencyName.message}
                    </span>
                )}
            </div>
        </div>
    );
}
